const _excluded = ["links", "pilePlacement", "pileAfterCount", "renderBreadcrumbButton", "renderBreadcrumbPile"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import { CrumbType, PilePlacement } from '../consts';
import { useBreadcrumbs } from '../hooks';
import { BreadcrumbTrail, BreadcrumbButton, BreadcrumbPile } from '../layout';
const Breadcrumbs = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      links,
      pilePlacement,
      pileAfterCount,
      renderBreadcrumbButton = crumb => /*#__PURE__*/React.createElement(BreadcrumbButton, crumb),
      renderBreadcrumbPile = pile => /*#__PURE__*/React.createElement(BreadcrumbPile, pile)
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    breadcrumbs
  } = useBreadcrumbs({
    links,
    pilePlacement,
    pileAfterCount
  });
  return /*#__PURE__*/React.createElement(BreadcrumbTrail, _extends({}, props, {
    ref: ref
  }), breadcrumbs.map(crumb => {
    switch (crumb.type) {
      case CrumbType.crumb:
        {
          return renderBreadcrumbButton(crumb);
        }
      case CrumbType.crumbPile:
        {
          return renderBreadcrumbPile(crumb);
        }
      default:
        {
          return null;
        }
    }
  }));
});
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  /** Links in the navigation that will be converted to breadcrumbs */
  links: PropTypes.array.isRequired,
  /** An enum for determining the location of the bread crumb pile when the links length
   *  extends past the pileAfterCount
   */
  pilePlacement: PropTypes.oneOf(Object.values(PilePlacement)),
  /** A positive integer representing when the breadcrumbs should collapse into using a
   *  pile
   */
  pileAfterCount: PropTypes.number,
  /** An override render prop for each breadcrumb link */
  renderBreadcrumbButton: PropTypes.func,
  /** An override render prop for each breadcrumb pile */
  renderBreadcrumbPile: PropTypes.func,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map